<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Benachrichtigungen"}}</h4>
</div>
<div class="modal-body">
	<div class="row">
	<div class="col-xs-12">
		<p class="m-b-20">
		{{TR "Wählen Sie die Portal-Ereignisse, über die Sie benachrichtigt werden möchten."}}
		</p>
	</div>
	</div>
	{{#each elements}}
		<div class="row">
		<div class="col-xs-12">
			<div class="checkbox checkbox-primary">
				<input id="js-info-{{id}}" class="js-info-toggle" type="checkbox" {{#if isEnabled}}checked="checcked"{{/if}}>
				<label for="js-info-{{id}}"><strong>{{text}}</strong></label>
			</div>
		</div>
		</div>
		<div class="row">
		<div class="col-xs-offset-1 col-xs-11 m-b-10">
			{{description}}
		</div>
		</div>
	{{/each}}
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button type="button" class="btn btn-primary" id="js-save">{{TR "Speichern"}}</button>
</div>
